import createPlugin from "./createPlugin";

import ArticlesRenderer from "./Renderer/ArticlesRenderer";
import ArticlesForm from "./Form/ArticlesForm";

const articlesPlugin = (settings) =>
    createPlugin({
        Renderer: ArticlesRenderer,
        Controls: ArticlesForm,
        ...settings,
    });

const articles = articlesPlugin();
export default articles;

export { articlesPlugin, ArticlesRenderer };
